// Converted to lazy loading
const suppliersIndex = () => import('@/pages/purchase/suppliers/index.vue')
const suppliersForm = () => import('@/pages/purchase/suppliers/form.vue')
const suppliersShow = () => import('@/pages/purchase/suppliers/show.vue')

const billsIndex = () => import('@/pages/purchase/bills/index.vue')
const billsForm = () => import('@/pages/purchase/bills/form.vue')
const billsShow = () => import('@/pages/purchase/bills/show.vue')

const purchaseReturnsIndex = () => import('@/pages/purchase/purchaseReturns/index.vue')
const purchaseReturnsForm = () => import('@/pages/purchase/purchaseReturns/form.vue')
const purchaseReturnsShow = () => import('@/pages/purchase/purchaseReturns/show.vue')

const purchaseOrdersIndex = () => import('@/pages/purchase/orders/index.vue')
const purchaseOrdersForm = () => import('@/pages/purchase/orders/form.vue')
const purchaseOrdersShow = () => import('@/pages/purchase/orders/show.vue')

const routes = [
  //suppliers routes
  {
    path: 'suppliers',
    name: 'suppliers',
    component: suppliersIndex
  },
  {
    path: 'suppliers/create',
    name: 'suppliersCreate',
    component: suppliersForm
  },
  {
    path: 'suppliers/:id/edit',
    name: 'suppliersEdit',
    component: suppliersForm
  },

  {
    path: 'suppliers/:id',
    name: 'suppliersShow',
    component: suppliersShow
  },

  //purchaseOrders routes

  {
    path: 'purchaseOrders',
    name: 'purchaseOrders',
    component: purchaseOrdersIndex
  },

  {
    path: 'purchaseOrders/create',
    name: 'purchaseOrdersCreate',
    component: purchaseOrdersForm
  },

  {
    path: 'purchaseOrders/:id/edit',
    name: 'purchaseOrdersEdit',
    component: purchaseOrdersForm
  },

  {
    path: 'purchaseOrders/:id',
    name: 'purchaseOrdersShow',
    component: purchaseOrdersShow
  },

  //bills routes

  {
    path: 'bills',
    name: 'bills',
    component: billsIndex
  },
  {
    path: 'bills/create',
    name: 'billsCreate',
    component: billsForm
  },

  {
    path: 'bills/:id/edit',
    name: 'billsEdit',
    component: billsForm
  },
  { path: 'bills/:id', name: 'billsShow', component: billsShow },

  //purchaseReturns routes

  {
    path: 'purchaseReturns',
    name: 'purchaseReturns',
    component: purchaseReturnsIndex
  },
  {
    path: 'purchaseReturns/create',
    name: 'purchaseReturnsCreate',
    component: purchaseReturnsForm
  },

  {
    path: 'purchaseReturns/:id/edit',
    name: 'purchaseReturnsEdit',
    component: purchaseReturnsForm
  },
  {
    path: 'purchaseReturns/:id',
    name: 'purchaseReturnsShow',
    component: purchaseReturnsShow
  },

  //purchaseOrders routes
  {
    path: 'purchaseOrders',
    name: 'purchaseOrders',
    component: purchaseOrdersIndex
  },
  {
    path: 'purchaseOrders/create',
    name: 'purchaseOrdersCreate',
    component: purchaseOrdersForm
  },
  {
    path: 'purchaseOrders/:id/edit',
    name: 'purchaseOrdersEdit',
    component: purchaseOrdersForm
  },
  {
    path: 'purchaseOrders/:id',
    name: 'purchaseOrdersShow',
    component: purchaseOrdersShow
  }
]

export default routes
